import React from 'react';
import './FeedFooterComment.css';
import { Link } from 'react-router-dom';
import {encrypt} from "../../../helpers/CryptoJs"
import iconPath from "../../../helpers/iconHelper";

const FeedFooterComment = (props) => { 

  /* const showCommentList = () => {
    props.showCommentList(props.feed_id);
  } */
  let link = '';
  if(props.data_type == 'ALBUM'){
    link = `/album/${encrypt(props.post_id)}`;
  }else if(props.data_type == 'Promotion'){
    link = `/promotion_detail/${encrypt(props.post_id)}`;
  }else if(props.data_type == 'POLL'){
    link = `/polling/${encrypt(props.feed_id)}`;
  }else{
    link = `/post/${encrypt(props.feed_id)}`;
  }

  let icon = iconPath['FEEDCOMMENT'];
  if(window.location.href.includes('promotion_detail')){
    icon = iconPath['FEEDCOMMENT'];
  }else if(window.location.href.includes('promotion')){
    icon = iconPath['PROMOTIONCOMMENT'];
  }else{
    icon = iconPath['FEEDCOMMENT'];
  }

  return ( 
    <a href={link} className="post-add-icon inline-items">
       
            <img style={{width: '30px'}} src={iconPath['FEEDCOMMENT']} /> 
       
        <span style={{color: 'rgb(136, 136, 142)'}}>
        {props.total_comment}
        </span>
    </a>
   
    
  );
};

export default FeedFooterComment;